<div class="fs-18px font-weight-bold">Create a Profile</div>

<div class="fs-15px mt-15px">
  {{ getCreateProfileMessage() }}
  <br />
  <br />
  <span *ngIf="globalVars.createProfileFeeNanos > 0">
    Creating a profile currently costs
    <b
      >{{ globalVars.createProfileFeeInDeSo() }} DeSo (≈
      {{ globalVars.createProfileFeeInUsd() }} USD)</b
    >
  </span>
</div>

<a
  class="mt-15px btn btn-primary br-12px"
  (click)="launchPhoneNumberVerification()"
>
  Get Starter DESO
</a>

<div class="fs-15px mt-15px">Or</div>

<div class="fs-15px mt-15px">
  <a
    href=""
    [routerLink]="'/' + globalVars.RouteNames.BUY_DESO"
    queryParamsHandling="merge"
  >
    Purchase {{ globalVars.createProfileFeeInUsd() }} USD of DeSo
  </a>
</div>
